import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from "react";
import _ from 'lodash'
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import ReactTimeout from 'react-timeout'
import i18n from 'utils/i18n'
import TextDivider from "components/atoms/TextDivider";
import EmployeeList, { EmployeeListModes } from 'components/organisms/EmployeeList'
import { EmployeePresentStatus } from 'utils/constants/EmployeePresentStatus'
import FetchCachedOtherEmployeeBookings from 'utils/fetch/cached/FetchCachedOtherEmployeeBookings'
import Loading from 'components/atoms/Loading'
import HelperString from 'utils/helper-string'
import { constantsActive } from 'utils/constants/constants'
import HelperPlatform from 'utils/helper-platform'
import WebSplitView from 'components/atoms/WebSplitView'
import { useIsSmallDevice } from 'utils/helper-device'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import selectFavourites from 'services/redux/data/selectors/selectFavourites'
import { dateFormat } from 'utils/helper-date'

const IndexFavouritePresenceSceneBlock = ({ selectedDate }) => {
	const isSmallDevice = useIsSmallDevice()
	
	const _employee_favourites = useSelector( selectFavourites )
	const _employees_bookings  = useSelector( state => {
		return state.data[dataConstants.EMPLOYEES_BOOKINGS];
	} );
	
	const [ bookedEmployees, setBookedEmployees ] = useState( null );
	const [ isLoading, setIsLoading ] = useState( {} );
	
	const fetchByDate = ( date ) => {
		FetchCachedOtherEmployeeBookings.fetchAll({
			bookingDate: date,
			callbackStart: setIsLoading.bind( this, {
				...isLoading,
				[ date.format( dateFormat.DATE ) ]: true
			}),
			callbackSuccess: setIsLoading.bind( this, {
				...isLoading,
				[ date.format( dateFormat.DATE ) ]: false
			}),
			callbackError: setIsLoading.bind( this, {
				...isLoading,
				[ date.format( dateFormat.DATE ) ]: false
			} )
		});
	}
	
	useEffect( () => {
		if( _.size( _employees_bookings ) > 0 && _.size( _employee_favourites ) > 0 ) {
			const selectedDateYmd = selectedDate.format( dateFormat.DATE )
			
			const _selectedDate_bookings = _.get( _employees_bookings, selectedDateYmd, undefined );
			let employees = [];
			
			if( _selectedDate_bookings !== undefined ) {
				setIsLoading({
					...isLoading,
					[ selectedDateYmd ]: false
				});
			}
			
			switch( true ) {
				case !_.isEmpty( _selectedDate_bookings ):
					//_.forEach( [ EmployeePresentStatus.PRESENT, EmployeePresentStatus.IN_MEETING, EmployeePresentStatus.HAVING_LUNCH, EmployeePresentStatus.NOT_YET_PRESENT, EmployeePresentStatus.LEFT, EmployeePresentStatus.UNKNOWN ], ( status ) => {
					_.forEach( EmployeePresentStatus, ( status ) => {
						_.forEach( _employee_favourites, ( _employee_favourite ) => {
							if( _employee_favourite.is_favourite === constantsActive.YES ) {
								let booking = _.get( _selectedDate_bookings, _employee_favourite?.guid, null );
								if( booking !== null && booking.status === status ){
									employees.push( _employee_favourite );
								}
							}
						});
					});
					
					setBookedEmployees( employees );
					break;
					
				case _selectedDate_bookings === undefined:
					fetchByDate( selectedDate );
					break;
					
				default:
					setBookedEmployees( employees );
			}
		} else if( _.size( _employee_favourites ) > 0 ){
			fetchByDate( selectedDate );
		}
	}, [ selectedDate, _employee_favourites, _employees_bookings ] );
	
	// No co-worker enabled? Return nothing
	if( !HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
		return null;
	}
	
	const items = [
		<TextDivider
			key={ HelperString.hash( 'employee_presence_text_divider', selectedDate.format( dateFormat.DATE ) ) }
			text={ i18n.t( 'pages.home.favourite_presence.title' ) }
			rowStyle={ staticStyles.textDividerMarginTop12 }
		/>
	];
	
	switch( true ) {
		case _.get( isLoading, selectedDate.format( dateFormat.DATE ), false ) === true:
			items.push(
				<Loading
					key={ HelperString.hash( 'employee_loading', selectedDate.format( dateFormat.DATE ) ) }
				/>
			);
			break;
		default:
			const dateLabel = selectedDate.format('D MMMM');
			
			items.push(
				<EmployeeList
					key={ HelperString.hash( `employee_list`, selectedDate ) }
					employees={ bookedEmployees }
					mode={ EmployeeListModes.PRESENCE }
					selectedDate={ selectedDate }
					showHeart={ false }
					scrollEnabled={ false }
					noResultText={ i18n.t( 'pages.home.favourite_presence.no_bookings_favourites', { date: dateLabel } )}
				/>
			);
	}
	
	if( HelperPlatform.isWeb() && !isSmallDevice ) {
		return (
			<WebSplitView rightItems={ items } />
		);
	}
	
	return items;
}

const staticStyles = StyleSheet.create({
	textDividerMarginTop12: {
		marginTop: 12,
	},
});

export default ReactTimeout( IndexFavouritePresenceSceneBlock )
